import React from 'react'
import PropTypes from 'prop-types'

import { ViewPropTypes, View } from 'react-native'
import Modal from 'react-native-modal'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './CustomModal.Styles'

function CustomModal({
  type,
  close,
  style,
  insets,
  visible,
  children,
  scrollable,
  contentContainerStyle
}) {
  const swipeDirection = {
    normal: 'down',
    full: null
  }[type]

  return (
    <Modal
      transparent
      propagateSwipe
      isVisible={visible}
      style={styles.modal}
      hardwareAccelerated
      backdropOpacity={0.5}
      scrollable={scrollable}
      onSwipeComplete={close}
      onBackdropPress={close}
      onBackButtonPress={close}
      backdropColor={Colors.black}
      hideModalContentWhileAnimating
      backdropTransitionOutTiming={0}
      swipeDirection={swipeDirection}
    >
      <View style={styles[`indicatorContainer_${type}`]}>
        <View style={styles[`topIndicator_${type}`]} />
      </View>
      <View
        style={[
          { paddingBottom: insets.bottom || 0 },
          styles[`main_${type}`],
          styles.main,
          style
        ]}
      >
        <View style={[styles.content, contentContainerStyle]}>{children}</View>
      </View>
    </Modal>
  )
}

CustomModal.defaultProps = {
  style: {},
  type: 'normal',
  insets: { bottom: 0 }
}

CustomModal.propTypes = {
  close: PropTypes.func,
  visible: PropTypes.bool,
  children: PropTypes.node,
  scrollable: PropTypes.bool,
  type: PropTypes.oneOf(['normal', 'full']),
  style: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style)
  ]),
  contentContainerStyle: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style)
  ]),
  insets: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    left: PropTypes.number,
    bottom: PropTypes.number
  })
}

export default CustomModal
